import { TimeslotApiModel } from 'common/timeslot/types';
import { EventUserStatuses } from 'common/user/enum';


export interface CreateFormattedTimeslotParams {
  timeslot?: TimeslotApiModel
  isSchool: boolean
  status: EventUserStatuses
}

export function createFormattedTimeslot(params: CreateFormattedTimeslotParams): string {
  const { timeslot, status, isSchool } = params;
  const statusIsSubscribed = status === EventUserStatuses.subscribed;

  if (!timeslot) {
    return '-';
  }

  const isFakeTimeslot = timeslot.timeInterval.endsWith('00:00-00:01');

  if (!(isSchool && statusIsSubscribed)) {
    return isFakeTimeslot ? 'Время уточняется' : timeslot.timeInterval.replace('-', '–');
  }

  return '–';
}
